{
  "title": "Welcome Back,",
  "exportdisabled": "Export bank statement is currently disabled. Sorry for the inconvenience.",
  "sections": {
    "accounts": "Accounts",
    "transactions": "Transactions",
    "payments": "Payments"
  },
  "option": {
    "home": "Home",
    "bank": "Bank",
    "otc": "OTC",
    "crypto": "Crypto",
    "exchange": "Exchange",
    "beneficiaries": "Beneficiaries",
    "web3": "Web3"
  },
  "cryto": {
    "alert": "ALERT: Deposits above 500k may take longer to process."
  },
  "card": {
    "addaccount": "Add Account",
    "deleteaccount": "Delete Account",
    "accountapproved": "Your new account has been successfully added.",
    "accountrejected": "Your account has not been added.",
    "deleteaccountwarning": "Are you sure you want to delete this account? This action cannot be undone."
  },
  "input": {
    "accounttype": "Account Type",
    "assettype": "Asset",
    "blockchain": "Blockchain"
  },
  "details": {
    "transactionid": "ID",
    "value": "Amount",
    "status": "Status",
    "date": "Date",
    "beneficiary": "Beneficiary",
    "originator": "Sender",
    "receiver": "Receiver",
    "address": "Institution Address",
    "city": "Institution City",
    "postalCode": "Institution ZIP Code",
    "originatorcountry": "Country",
    "institutionName": "Institution Name",
    "accountNumber": "Account Number",
    "iban": "IBAN Code",
    "rail": "Rail",
    "type": "Account Type",
    "routingNumber": "Routing Number",
    "swiftBic": "SWIFT Code",
    "description": "Description",
    "memo": "MEMO",
    "destinationId": "Destination Account ID",
    "sourceDetails": "Source Details",
    "sourceId": "Source Account ID",
    "amountCredited": "Amount Credited",
    "amountDebited": "Amount Debited",
    "assetType": "Asset Type",
    "transactionType": "Transaction Type",
    "exchangeRate": "Exchange Rate",
    "amountToDebit": "Amount To Debit",
    "amountToCredit": "Amount To Credit",
    "sourceAssetTypeId": "Source Asset",
    "sourceAccountId": "Source Account ID",
    "sourceAccountIdId": "Source Account ID",
    "sourceFirstName": "Originator First Name",
    "sourceMiddleName": "Originator Middle Name",
    "sourceLastName": "Originator Last Name",
    "sourceRegisteredName": "Originator Registered Name",
    "sourceTradingName": "Originator Trading Name",
    "destinationAccountId": "Recipient Account ID",
    "destinationAccountIdId": "Recipient Account ID",
    "destinationAssetTypeId": "Recipient Asset",
    "destinationFirstName": "Recipient First Name",
    "destinationMiddleName": "Recipient Middle Name",
    "destinationLastName": "Recipient Last Name",
    "destinationRegisteredName": "Recipient Registered Name",
    "destinationTradingName": "Recipient Trading Name",
    "railOriginatorMemo": "MEMO",
    "purpose": "Purpose",
    "cpName": "Recipient Name",
    "cpInstitutionName": "Institution Name",
    "cpAccountNumber": "Account Number",
    "cpRoutingNumber": "Routing Number",
    "cpIban": "IBAN Code",
    "cpSwiftBic": "SWIFT Code",
    "name": "Name",
    "cpWalletAddress": "Wallet Address",
    "cpBlockchainAddress": "Wallet Address",
    "cpCryptoAssetTypeId": "Asset Type",
    "accountId": "Account ID"
  },
  "transaction": {
    "modal": {
      "title": "Accept/Decline Transaction",
      "content": "Please, select an follow action to ACCEPT or DECLINE the transaction in amount of"
    }
  },
  "errors": {
    "filter": "Error filtering transactions. Please try again."
  }
}
